
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms/[slug]/thank-you",
      function () {
        return require("private-next-pages/forms/[slug]/thank-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms/[slug]/thank-you"])
      });
    }
  